import { useTranslation } from 'react-i18next'
import { useSettingsStore } from '@/state/useSettingsStore'
import clsx from 'clsx'

export function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const locale = useSettingsStore((s) => s.locale)
  const setLocale = useSettingsStore((s) => s.setLocale)

  function pick(next: 'cs' | 'en') {
    setLocale(next)
    void i18n.changeLanguage(next)
  }

  return (
    <div
      role="group"
      aria-label="Language"
      className="inline-flex items-center rounded-full border border-border bg-surface-1/80 p-0.5 text-xs font-medium backdrop-blur"
    >
      {(['cs', 'en'] as const).map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => pick(l)}
          className={clsx(
            'rounded-full px-3 py-1 transition',
            locale === l ? 'bg-brand-primary text-ink-inverse' : 'text-ink-muted hover:text-ink',
          )}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  )
}
